import {Deserializable} from "./deserializable.model";

export class JobTypeCourt {

job_type_court_id: number;
job_type_court_name: string;
job_type_court_description: string;
is_active: string;
job_type_location_id: number;
job_type_id: number;



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobTypeCourt {
    Object.assign(this, input);

    return this;
  }


}
